import {Badge, Group, UnstyledButton} from "@mantine/core";
import {useMemo} from "react";
import {useNavigate} from "react-router-dom";
import {useGetPendingDispatchRequests} from "../../hooks/useGetPendingDispatchRequests";
import {ContainerLevelSimulationBadge} from "@ots-frontend/ots-ui-tw";

export type NavHeaderIslandProps = {
  // props here
}

export const NavHeaderIsland = (props: NavHeaderIslandProps) => {
  const navigate = useNavigate()

  const {dispatchRequests} = useGetPendingDispatchRequests();

  const pendingDispatchRequestCount = useMemo(() => {
    return dispatchRequests.length
  }, [dispatchRequests])

  return (
    <Group position="left">
      <ContainerLevelSimulationBadge onClick={() => navigate("/directory")}/>
      {pendingDispatchRequestCount &&
        <UnstyledButton onClick={() => navigate("/requests/pending")}>
          <Badge size="sm" variant="filled" color="service-work">
            {`${pendingDispatchRequestCount} Pending Dispatch Requests`}
          </Badge>
        </UnstyledButton>
      }
    </Group>
  );
};
